module.exports = __webpack_public_path__ + "static/media/seratoImg.9c2f31a8.png";